// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/Koulen-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: roboto-regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.title {
  margin-top: 1vh;
  margin-bottom: 1vh;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: rgb(0, 0, 0);
  font-size: 70px;
}
.sub-title {
  margin-top: 0.5vh;
  padding-top: 0vh;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2vh;
  text-align: center;
  color: rgb(227, 230, 232);
  font-size: 50px;
}
.main {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgb(78, 171, 218);
  /* background: url('../../static/hexmap_background.png') no-repeat ;
  background-image: url('../../static/hexmap_background.png') no-repeat ; */
  background-size: cover;
}

@media only screen and (max-height: 950px) {
  .title {
    margin-top: 1vh;
    margin-bottom: 1vh;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: rgb(255, 255, 255);
    font-size: 70px;
  }
  .sub-title {
    margin-top: 0.5vh;
    padding-top: 0vh;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2vh;
    text-align: center;
    color: rgb(227, 230, 232);
    font-size: 50px;
  }
}

@media only screen and (max-width: 384px) {
  .main {
    position: fixed;
    /* height:100%; */
    width: 100%;
    margin-top: 0vh;
    margin: 0%;
    padding: 0px;
    /* background: url('../../static/hexmap_background.png') no-repeat ;
      background-image: url('../../static/hexmap_background.png') no-repeat ; */
    background-size: cover;
  }

  .title {
    margin-top: 1vh;
    margin-bottom: 4vh;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: rgb(255, 255, 255);
    font-size: 40px;
  }
  .sub-title {
    margin-top: 0.5vh;
    padding-top: 0vh;
    padding-left: 0.7vw;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2vh;
    text-align: center;
    color: rgb(227, 230, 232);
    font-size: 30px;
  }
}

@media only screen and (max-height: 384px) {
  .main {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 76%;
    /* margin-top:0vh; */
    /* margin:0%;
      padding:0px; */
    /* background: url('../../static/hexmap_background.png') no-repeat ;
      background-image: url('../../static/hexmap_background.png') no-repeat ; */
    background-size: cover;
    justify-content: center;
    align-items: center;
  }

  img {
    display: block;
    margin-top: 1vh;
    margin-left: auto;
    margin-right: auto;
  }

  .title {
    margin-left: auto;
    margin-right: auto;
    margin-top: 0vh;
    text-align: center;
    color: rgb(255, 255, 255);
    font-size: 40px;
  }
  .sub-title {
    position: "absolute";
    float: "left";
    margin-top: 0.5vh;
    padding-top: 0vh;
    padding-left: 0.7vw;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2vh;
    text-align: center;
    color: rgb(227, 230, 232);
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Main/styles.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,4CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC;2EACyE;EAIzE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,UAAU;IACV,YAAY;IACZ;+EAC2E;IAI3E,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB;oBACgB;IAChB;+EAC2E;IAI3E,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;AACF","sourcesContent":["@font-face {\n  font-family: roboto-regular;\n  src: url(\"../../static/Koulen-Regular.ttf\");\n}\n\n.title {\n  margin-top: 1vh;\n  margin-bottom: 1vh;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  color: rgb(0, 0, 0);\n  font-size: 70px;\n}\n.sub-title {\n  margin-top: 0.5vh;\n  padding-top: 0vh;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 2vh;\n  text-align: center;\n  color: rgb(227, 230, 232);\n  font-size: 50px;\n}\n.main {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  background-color: rgb(78, 171, 218);\n  /* background: url('../../static/hexmap_background.png') no-repeat ;\n  background-image: url('../../static/hexmap_background.png') no-repeat ; */\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n}\n\n@media only screen and (max-height: 950px) {\n  .title {\n    margin-top: 1vh;\n    margin-bottom: 1vh;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    color: rgb(255, 255, 255);\n    font-size: 70px;\n  }\n  .sub-title {\n    margin-top: 0.5vh;\n    padding-top: 0vh;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 2vh;\n    text-align: center;\n    color: rgb(227, 230, 232);\n    font-size: 50px;\n  }\n}\n\n@media only screen and (max-width: 384px) {\n  .main {\n    position: fixed;\n    /* height:100%; */\n    width: 100%;\n    margin-top: 0vh;\n    margin: 0%;\n    padding: 0px;\n    /* background: url('../../static/hexmap_background.png') no-repeat ;\n      background-image: url('../../static/hexmap_background.png') no-repeat ; */\n    -webkit-background-size: cover;\n    -moz-background-size: cover;\n    -o-background-size: cover;\n    background-size: cover;\n  }\n\n  .title {\n    margin-top: 1vh;\n    margin-bottom: 4vh;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    color: rgb(255, 255, 255);\n    font-size: 40px;\n  }\n  .sub-title {\n    margin-top: 0.5vh;\n    padding-top: 0vh;\n    padding-left: 0.7vw;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 2vh;\n    text-align: center;\n    color: rgb(227, 230, 232);\n    font-size: 30px;\n  }\n}\n\n@media only screen and (max-height: 384px) {\n  .main {\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 76%;\n    /* margin-top:0vh; */\n    /* margin:0%;\n      padding:0px; */\n    /* background: url('../../static/hexmap_background.png') no-repeat ;\n      background-image: url('../../static/hexmap_background.png') no-repeat ; */\n    -webkit-background-size: cover;\n    -moz-background-size: cover;\n    -o-background-size: cover;\n    background-size: cover;\n    justify-content: center;\n    align-items: center;\n  }\n\n  img {\n    display: block;\n    margin-top: 1vh;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .title {\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 0vh;\n    text-align: center;\n    color: rgb(255, 255, 255);\n    font-size: 40px;\n  }\n  .sub-title {\n    position: \"absolute\";\n    float: \"left\";\n    margin-top: 0.5vh;\n    padding-top: 0vh;\n    padding-left: 0.7vw;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 2vh;\n    text-align: center;\n    color: rgb(227, 230, 232);\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
